
import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';
import style from './index.module.css'
export default function Home() {
  return (
    <div className={style.home}>
    <div className='container '>
      {/* <div>
        <div className={style.text}>
          <p>Categories <i class="fa-solid fa-layer-group"></i></p>
          <h1>Browse by Category </h1>
        </div>
      
        <div className={style.cat}>
          <div className={style.card1}>
            <img src='elec-1.png'></img>
            <p>Video-Games</p>
          </div>
          <div className={style.card1}>
            <img src='elec-4.png'></img>
            <p>Video-Games</p>
          </div>
          <div className={style.card1}>
            <img src='elec-5.png'></img>
            <p>Video-Games</p>
          </div>
          <div className={style.card1}>
            <img src='elec-8.png'></img>
            <p>Video-Games</p>
          </div>
          <div className={style.card1}>
            <img src='elec-11.png'></img>
            <p>Video-Games</p>
          </div>
          <div className={style.card1}>
            <img src='elec-9.png'></img>
            <p>Video-Games</p>
          </div>
        </div>
      </div> */}
    </div>
    <div>



      
      <div className={style.text1}>
        <p>Our Products <i class="fa-solid fa-layer-group"></i></p>
        <h1>Explore Our Products </h1>
      </div>
      <div className={style.product}>
        <div className={style.card2}>
          <div className={style.img}>
            <img src='product-01.png'></img>  
            <div className={style.read}>
              <a href='' className={style.fa}><i class="fa-brands fa-readme"></i></a>
              <a href='' className={style.add}>Add to cart</a>
              <a href='' className={style.fa}><i className="fa-regular fa-heart"></i></a>
            </div>
          </div>  
          <div className={style.text2}>
            <h4>Level 20 RGB Cherry</h4>
            <p>$ 29.99</p>
          </div>
        </div>    
        <div className={style.card2}>
          <div className={style.img}>
            <img src='product-38.png'></img>  
            <div className={style.read}>
              <a href='' className={style.fa}><i class="fa-brands fa-readme"></i></a>
              <a href='' className={style.add}>Add to cart</a>
              <a href='' className={style.fa}><i className="fa-regular fa-heart"></i></a>
            </div>
          </div>  
          <div className={style.text2}>
            <h4>Level 20 RGB Cherry</h4>
            <p>$ 29.99</p>
          </div>
        </div>        
        <div className={style.card2}>
          <div className={style.img}>
            <img src='product-39.png'></img>  
            <div className={style.read}>
              <a href='' className={style.fa}><i class="fa-brands fa-readme"></i></a>
              <a href='' className={style.add}>Add to cart</a>
              <a href='' className={style.fa}><i className="fa-regular fa-heart"></i></a>
            </div>
          </div>  
          <div className={style.text2}>
            <h4>Level 20 RGB Cherry</h4>
            <p>$ 29.99</p>
          </div>
        </div>        
        <div className={style.card2}>
          <div className={style.img}>
            <img src='product-01.png'></img>  
            <div className={style.read}>
              <a href='' className={style.fa}><i class="fa-brands fa-readme"></i></a>
              <a href='' className={style.add}>Add to cart</a>
              <a href='' className={style.fa}><i className="fa-regular fa-heart"></i></a>
            </div>
          </div>  
          <div className={style.text2}>
            <h4>Level 20 RGB Cherry</h4>
            <p>$ 29.99</p>
          </div>
        </div>        
        <div className={style.card2}>
          <div className={style.img}>
            <img src='product-38.png'></img>  
            <div className={style.read}>
              <a href='' className={style.fa}><i class="fa-brands fa-readme"></i></a>
              <a href='' className={style.add}>Add to cart</a>
              <a href='' className={style.fa}><i className="fa-regular fa-heart"></i></a>
            </div>
          </div>  
          <div className={style.text2}>
            <h4>Level 20 RGB Cherry</h4>
            <p>$ 29.99</p>
          </div>
        </div>        
        <div className={style.card2}>
          <div className={style.img}>
            <img src='product-01.png'></img>  
            <div className={style.read}>
              <a href='' className={style.fa}><i class="fa-brands fa-readme"></i></a>
              <a href='' className={style.add}>Add to cart</a>
              <a href='' className={style.fa}><i className="fa-regular fa-heart"></i></a>
            </div>
          </div>  
          <div className={style.text2}>
            <h4>Level 20 RGB Cherry</h4>
            <p>$ 29.99</p>
          </div>
        </div>        
        <div className={style.card2}>
          <div className={style.img}>
            <img src='product-39.png'></img>  
            <div className={style.read}>
              <a href='' className={style.fa}><i class="fa-brands fa-readme"></i></a>
              <a href='' className={style.add}>Add to cart</a>
              <a href='' className={style.fa}><i className="fa-regular fa-heart"></i></a>
            </div>
          </div>  
          <div className={style.text2}>
            <h4>Level 20 RGB Cherry</h4>
            <p>$ 29.99</p>
          </div>
        </div>      
        <div className={style.card2}>
          <div className={style.img}>
            <img src='product-01.png'></img>  
            <div className={style.read}>
              <a href='' className={style.fa}><i class="fa-brands fa-readme"></i></a>
              <a href='' className={style.add}>Add to cart</a>
              <a href='' className={style.fa}><i className="fa-regular fa-heart"></i></a>
            </div>
          </div>  
          <div  className={style.text2}> 
            <h4>Level 20 RGB Cherry</h4>
            <p>$ 29.99</p>
          </div>
        </div>        
      </div>
      <div className={style.all}>
           <a href='/Shop'>View All Product</a>
      </div>
    </div>
    <div>
      <div className={style.this}>
        <p>This Week <i class="fa-solid fa-cart-shopping"></i></p>
        <h1>New Arrivals </h1>
      </div>
      <Swiper
        slidesPerView={1}
        spaceBetween={10}
        pagination={{
          clickable: true,
        }}
        breakpoints={{
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
          1024: {
            slidesPerView: 5,
            spaceBetween: 50,
          },
        }}
        modules={[Pagination]}
        className={style.mySwiper}
      >
        <SwiperSlide>
          <div className={style.sekil}>
            <img src='https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-06.png'></img>
          </div>
          <div className={style.yazi}>
              <div className=''>
                <p>Google Home</p>
                <h4>$ 40</h4>
              </div>
              <div className={style.read1}>
                  <a href='' className={style.fa}><i class="fa-brands fa-readme"></i></a>
                  <a href='' className={style.add}>Add to cart</a>
                  <a href='' className={style.fa}><i className="fa-regular fa-heart"></i></a>
                </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
        <div className={style.sekil}>
            <img src='https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-07.png'></img>
          </div>
          <div className={style.yazi}>
              <div className=''>
                <p>Google Home</p>
                <h4>$ 40</h4>
              </div>
              <div className={style.read1}>
                  <a href='' className={style.fa}><i class="fa-brands fa-readme"></i></a>
                  <a href='' className={style.add}>Add to cart</a>
                  <a href='' className={style.fa}><i className="fa-regular fa-heart"></i></a>
                </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
        <div className={style.sekil}>
            <img src='https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-06.png'></img>
          </div>
          <div className={style.yazi}>
              <div className=''>
                <p>Google Home</p>
                <h4>$ 40</h4>
              </div>
              <div className={style.read1}>
                  <a href='' className={style.fa}><i class="fa-brands fa-readme"></i></a>
                  <a href='' className={style.add}>Add to cart</a>
                  <a href='' className={style.fa}><i className="fa-regular fa-heart"></i></a>
                </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
        <div className={style.sekil}>
            <img src='https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-04.png'></img>
          </div>
          <div className={style.yazi}>
              <div className=''>
                <p>Google Home</p>
                <h4>$ 40</h4>
              </div>
              <div className={style.read1}>
                  <a href='' className={style.fa}><i class="fa-brands fa-readme"></i></a>
                  <a href='' className={style.add}>Add to cart</a>
                  <a href='' className={style.fa}><i className="fa-regular fa-heart"></i></a>
                </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
        <div className={style.sekil}>
            <img src='https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-06.png'></img>
          </div>
          <div className={style.yazi}>
              <div className=''>
                <p>Google Home</p>
                <h4>$ 40</h4>
              </div>
              <div className={style.read1}>
                  <a href='' className={style.fa}><i class="fa-brands fa-readme"></i></a>
                  <a href='' className={style.add}>Add to cart</a>
                  <a href='' className={style.fa}><i className="fa-regular fa-heart"></i></a>
                </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
        <div className={style.sekil}>
            <img src='https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-04.png'></img>
          </div>
          <div className={style.yazi}>
              <div className=''>
                <p>Google Home</p>
                <h4>$ 40</h4>
              </div>
              <div className={style.read1}>
                  <a href='' className={style.fa}><i class="fa-brands fa-readme"></i></a>
                  <a href='' className={style.add}>Add to cart</a>
                  <a href='' className={style.fa}><i className="fa-regular fa-heart"></i></a>
                </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
        <div className={style.sekil}>
            <img src='https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-04.png'></img>
          </div>
          <div className={style.yazi}>
              <div className=''>
                <p>Google Home</p>
                <h4>$ 40</h4>
              </div>
              <div className={style.read1}>
                  <a href='' className={style.fa}><i class="fa-brands fa-readme"></i></a>
                  <a href='' className={style.add}>Add to cart</a>
                  <a href='' className={style.fa}><i className="fa-regular fa-heart"></i></a>
                </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
        <div className={style.sekil}>
            <img src='https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-06.png'></img>
          </div>
          <div className={style.yazi}>
              <div className=''>
                <p>Google Home</p>
                <h4>$ 40</h4>
              </div>
              <div className={style.read1}>
                  <a href='' className={style.fa}><i class="fa-brands fa-readme"></i></a>
                  <a href='' className={style.add}>Add to cart</a>
                  <a href='' className={style.fa}><i className="fa-regular fa-heart"></i></a>
                </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
        <div className={style.sekil}>
            <img src='https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-04.png'></img>
          </div>
          <div className={style.yazi}>
              <div className=''>
                <p>Google Home</p>
                <h4>$ 40</h4>
              </div>
              <div className={style.read1}>
                  <a href='' className={style.fa}><i class="fa-brands fa-readme"></i></a>
                  <a href='' className={style.add}>Add to cart</a>
                  <a href='' className={style.fa}><i className="fa-regular fa-heart"></i></a>
                </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
        <div className={style.sekil}>
            <img src='https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-07.png'></img>
          </div>
          <div className={style.yazi}>
              <div className=''>
                <p>Google Home</p>
                <h4>$ 40</h4>
              </div>
              <div className={style.read1}>
                  <a href='' className={style.fa}><i class="fa-brands fa-readme"></i></a>
                  <a href='' className={style.add}>Add to cart</a>
                  <a href='' className={style.fa}><i className="fa-regular fa-heart"></i></a>
                </div>
          </div>
        </SwiperSlide>
       
      </Swiper>
    
    </div>
    <div className={style.most}>
      <div className={style.title}>
        <p>Most Sold <i class="fa-solid fa-star"></i></p>
        <h2>Most Sold in eTrade Store</h2>
      </div>
      <div className={style.mostpr}>
        <div className={style.most1}>
          <div className={style.img1}><img src='https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-09.png'></img></div>
          <div className={style.yazi1}>
            <p>Media Remote</p>
            <p>$ 29.00</p>
          </div>
          <div className={style.sebet}>
            <div><a href=''><i className="fa-regular fa-heart"></i></a></div>
            <div><a href=''><i className="fa-solid fa-cart-shopping"></i></a></div>
          </div>
        </div>
        <div className={style.most1}>
          <div className={style.img1}><img src='https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-10.png'></img></div>
          <div className={style.yazi1}>
            <p>Media Remote</p>
            <p>$ 29.00</p>
          </div>
          <div className={style.sebet}>
            <div><a href=''><i className="fa-regular fa-heart"></i></a></div>
            <div><a href=''><i className="fa-solid fa-cart-shopping"></i></a></div>
          </div>
        </div>
        <div className={style.most1}>
          <div className={style.img1}><img src='https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-16.png'></img></div>
          <div className={style.yazi1}>
            <p>Media Remote</p>
            <p>$ 29.00</p>
          </div>
          <div className={style.sebet}>
            <div><a href=''><i className="fa-regular fa-heart"></i></a></div>
            <div><a href=''><i className="fa-solid fa-cart-shopping"></i></a></div>
          </div>
        </div>
        <div className={style.most1}>
          <div className={style.img1}><img src='https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-12.png'></img></div>
          <div className={style.yazi1}>
            <p>Media Remote</p>
            <p>$ 29.00</p>
          </div>
          <div className={style.sebet}>
            <div><a href=''><i className="fa-regular fa-heart"></i></a></div>
            <div><a href=''><i className="fa-solid fa-cart-shopping"></i></a></div>
          </div>
        </div>
        <div className={style.most1}>
          <div className={style.img1}><img src='https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-11.png'></img></div>
          <div className={style.yazi1}>
            <p>Media Remote</p>
            <p>$ 29.00</p>
          </div>
          <div className={style.sebet}>
            <div><a href=''><i className="fa-regular fa-heart"></i></a></div>
            <div><a href=''><i className="fa-solid fa-cart-shopping"></i></a></div>
          </div>
        </div>
        <div className={style.most1}>
          <div className={style.img1}><img src='https://new.axilthemes.com/demo/template/etrade/assets/images/product/electric/product-13.png'></img></div>
          <div className={style.yazi1}>
            <p>Media Remote</p>
            <p>$ 29.00</p>
          </div>
          <div className={style.sebet}>
            <div><a href=''><i className="fa-regular fa-heart"></i></a></div>
            <div><a href=''><i className="fa-solid fa-cart-shopping"></i></a></div>
          </div>
        </div>
      </div>
    </div>
    <div className={style.why}>
      <div className={style.yazi2}>
        <p>Why Us <i class="fa-solid fa-thumbs-up"></i></p>
        <h2>Why People Choose Us</h2>
      </div>
      <div className={style.why1}>
        <div className={style.why2}>
          <img src='https://new.axilthemes.com/demo/template/etrade/assets/images/icons/service6.png'></img>
          <p>Fast & Secure Delivery</p>
        </div>
        <div className={style.why2}>
          <img src='https://new.axilthemes.com/demo/template/etrade/assets/images/icons/service7.png'></img>
          <p>100% Guarantee On Product</p>
        </div>
        <div className={style.why2}>
          <img src='https://new.axilthemes.com/demo/template/etrade/assets/images/icons/service8.png'></img>
          <p>24 Hour Return Policy</p>
        </div>
        <div className={style.why2}>
          <img src='https://new.axilthemes.com/demo/template/etrade/assets/images/icons/service9.png'></img>
          <p>Fast & Secure Delivery</p>
        </div>
        <div className={style.why2}>
          <img src='https://new.axilthemes.com/demo/template/etrade/assets/images/icons/service10.png'></img>
          <p>Next Level Pro Quality</p>
        </div>
      </div>
    </div>
    </div>
  )
}
